// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gBAF","controls":"styles_controls__3SkUW","charLimit":"styles_charLimit__YFukl","input":"styles_input__3jNRu","send":"styles_send__fdHFY"};